export enum ClientDeviceType {
    KIOSK = 'kiosk',
    STATIC_DISPLAY = 'static display',
    TABLET = 'tablet',
}